/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */

/**
 * The type of the column
 */
export type ControlResultColumnResponseDtoType = typeof ControlResultColumnResponseDtoType[keyof typeof ControlResultColumnResponseDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ControlResultColumnResponseDtoType = {
  INTEGER: 'INTEGER',
  DECIMAL: 'DECIMAL',
  MONEY_K: 'MONEY_K',
  MONEY: 'MONEY',
  MONETARY: 'MONETARY',
  SHORT_DATE: 'SHORT_DATE',
  LONG_DATE: 'LONG_DATE',
  DAY_OF_WEEK: 'DAY_OF_WEEK',
  HOUR_DATE: 'HOUR_DATE',
  MONTH_DATE: 'MONTH_DATE',
  BOOLEAN: 'BOOLEAN',
  BOOLEAN_DISPLAY: 'BOOLEAN_DISPLAY',
  LIST: 'LIST',
  LIST_OF_VALUES: 'LIST_OF_VALUES',
  TEXT: 'TEXT',
  LABEL_ML: 'LABEL_ML',
  TEXT_ML_COMBINED: 'TEXT_ML_COMBINED',
  TO_DETERMINE: 'TO_DETERMINE',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  CALCULATED_FIELD: 'CALCULATED_FIELD',
  PERCENTAGE: 'PERCENTAGE',
  PERCENTAGE_WITH_TWO_DECIMALS: 'PERCENTAGE_WITH_TWO_DECIMALS',
  PERCENTAGE_WITH_THREE_DECIMALS: 'PERCENTAGE_WITH_THREE_DECIMALS',
  GROUPING_RECURSIVITY: 'GROUPING_RECURSIVITY',
} as const;
